import React, { useState } from 'react';
import { cn } from '../../lib/utils';
import { Button } from '../ui/Button';
export type TimeframeOption = 'Today' | 'Yesterday' | 'This Week' | 'Last Week' | 'This Month' | 'Custom Range';
interface TimeframeSelectorProps {
  selected: TimeframeOption;
  onChange: (option: TimeframeOption) => void;
}
export function TimeframeSelector({
  selected,
  onChange
}: TimeframeSelectorProps) {
  const options: TimeframeOption[] = ['Today', 'Yesterday', 'This Week', 'Last Week', 'This Month', 'Custom Range'];
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  return <div className="flex flex-col gap-3 mb-6" data-id="element-295">
      <div className="flex flex-wrap items-center gap-2" data-id="element-296">
        <div className="flex flex-wrap bg-slate-100 p-1 rounded-xl" data-id="element-297">
          {options.map(option => <button key={option} onClick={() => onChange(option)} className={cn('px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200', selected === option ? 'bg-white text-indigo-700 shadow-sm' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-200/50')} data-id="element-298">
              {option}
            </button>)}
        </div>
      </div>

      {selected === 'Custom Range' && <div className="flex items-end gap-3 p-4 bg-white rounded-xl border border-slate-200 shadow-sm animate-in fade-in slide-in-from-top-2 duration-200 max-w-fit" data-id="element-299">
          <div className="flex flex-col gap-1.5" data-id="element-300">
            <label htmlFor="start-date" className="text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-301">
              Start Date
            </label>
            <input type="date" id="start-date" value={startDate} onChange={e => setStartDate(e.target.value)} className="h-10 px-3 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-302" />
          </div>
          <div className="flex flex-col gap-1.5" data-id="element-303">
            <label htmlFor="end-date" className="text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-304">
              End Date
            </label>
            <input type="date" id="end-date" value={endDate} onChange={e => setEndDate(e.target.value)} className="h-10 px-3 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-305" />
          </div>
          <Button variant="primary" className="h-10" data-id="element-306">
            Apply
          </Button>
        </div>}
    </div>;
}